<section class="main-section p-2">

    <div class="breadcrumb-container row gx-0 gy-0 p-2 w-100">

        <div class="d-flex align-items-center col-auto px-1">

            <span class="w-100 d-flex align-items-center" routerLink="/partners/dashboard">

                پنل داشبورد
                
            </span>

        </div>

        <div class="chevron-icon d-flex align-items-center col-auto px-1 ">

            <span class="w-100 d-flex align-items-center">

                <mat-icon class="text-muted">chevron_left</mat-icon>
                
            </span>

        </div>

        <div class="d-flex align-items-center col-auto px-1">

            <span class="w-100 d-flex align-items-center">

                سفرهای من
                
            </span>

        </div>

    </div>

    <div class="table-container">

        <div class="border border-2 p-2" >

            <input class="w-100 form-control" placeholder="جستجو کنید ..." #keyValue (keyup)="filter_list($event.target)">

            <div class="section border border-2 mt-2">

                <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                    <thead>
            
                        <tr class="">
            
                            <th class="text-center"> # </th>
        
                            <th class="text-center"> کد سفر  </th>
        
                            <th class="text-center"> تاریخ سفر  </th>
                            
                            <th class="text-center"> مبداء  </th>
        
                            <th class="text-center"> مقصد </th>
            
                            <th class="text-center"> مسافر </th>
                    
                            <th class="text-center"> کرایه(ریال) </th>
    
                            <th class="text-center"> مبلغ اعلامی(ریال) </th>
    
                            <th class="text-center">  مبلغ دریافتی(ریال) </th>
    
                            <th class="text-center"> بدهکاری/بستانکاری (ریال) </th>
    
                        </tr>
                        
                    </thead>

                    <tbody>

                        <tr class="col-12 text-center" *ngFor="let item of lst_Trip;let i = index">

                            <th> {{ i + 1 | faNum }} </th>

                            <td> {{ item.iTaxiLon_Trip | faNum }} </td>

                            <td> {{ item.strDate | faNum }} </td>

                            <td [innerHTML]="highlightText(item.strSCityName,keyValue.value) | faNum"> </td>

                            <td [innerHTML]="highlightText(item.strDCityName,keyValue.value) | faNum"> </td>

                            <td [innerHTML]="highlightText(item.strFullName,keyValue.value) | faNum"> </td>

                            <td> {{ item.iFinalRent | number:'1.0-0' | faNum }} </td>

                            <td> {{ item.iPartnerRent | number:'1.0-0' | faNum }} </td>

                            <td> {{ item.iPartnerReceived | number:'1.0-0' | faNum }} </td>

                            <td> {{ item.iCreditDebit | number:'1.0-0' | faNum }} </td>

                        </tr>

                    </tbody>

                </table>

            </div>

            <div class="row justify-content-center gx-0 gy-0 p-2" style="background-color: #6C757D;">

                <span class="col-md-auto col-12 text-white"> سرجمع بدهکاری/بستانکاری : 
                    
                    <span class="text-primary fw-bold"> 
                        
                        {{ iDebitCredit | number:'1.0-0' | faNum }} ریال 
                    
                    </span>

                </span>
    
            </div>

        </div>

    </div>

</section>